import { render } from "./EmployeeClaims.vue?vue&type=template&id=01d82e88&scoped=true"
import script from "./EmployeeClaims.vue?vue&type=script&lang=js"
export * from "./EmployeeClaims.vue?vue&type=script&lang=js"

import "./EmployeeClaims.vue?vue&type=style&index=0&id=01d82e88&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d82e88"]])

export default __exports__